"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const settings_about_1 = require("../components/settings-about");
const SettingsAbout = () => (React.createElement("div", { className: 'vf-bg-white-color full-viewport-height' },
    React.createElement(settings_about_1.default, null)));
exports.default = SettingsAbout;
